module.exports = __webpack_public_path__ + "img/normal-ticket-u.44f09a74.png";